 <uitk-loading-indicator uitkId="spinner" [visibleText]="visibleTextValue"spinnerSize="large"  > </uitk-loading-indicator>